class PopupUtil {
    constructor(){}

    // 화면 중앙에 팝업되도록 left, top 옵션 추가(있으면 업데이트)
    // width, height를 포함하는 option을 파라미터로 넘겨야 함. ex) 'width=1330,height=1080,location=no,menubar=no,status=no,toolbar=no,resizable=yes'
    // width 또는 height option이 없으면 옵션 추가 없이 그대로 리턴.
    getCenterPopupOption(option) {
        let obj = this.optionStringToObject(option);

        if (obj.width == null || obj.height == null) {
            return option;
        }

        obj.left = Math.ceil((window.outerWidth - obj.width) / 2) + window.screenLeft;
        obj.top = Math.ceil((window.outerHeight - obj.height) / 2) + window.screenTop;

        return this.objectToOptionString(obj);
    }

    // window option string을 object로 변환
    optionStringToObject(option) {
        return _.chain(option)
                    .replace(' ', '') // "width=1330,height=1080,location=no,menubar=no,status=no,toolbar=no,resizable=yes"
                    .split(',') // ["width=1330","height=1080","location=no","menubar=no","status=no","toolbar=no","resizable=yes"]
                    .map(_.partial(_.split, _, '=', 2)) // [["width","1330"],["height","1080"],["location","no"],["menubar","no"],["status","no"],["toolbar","no"],["resizable","yes"]]
                    .fromPairs() // {"width":"1330","height":"1080","location":"no","menubar":"no","status":"no","toolbar":"no","resizable":"yes"}
                    .value();
    }

    // window option object를 string으로 변환
    objectToOptionString(obj) {
        let optionString = '';

        for (var key in obj) {
            optionString += key + '=' + obj[key] + ',';
        }

        optionString = optionString.replace(/,$/, ''); // 문자열이 comma(,)로 끝나면 comma(,) 삭제

        return optionString;
    }

}

export default PopupUtil;